import { videoUrl } from '@helpers/cloudinary';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { withMotionMax } from '@hoc/withMotionMax';
import { useModalGallery } from '@hooks/useModalGallery';
import { ReactComponent as SvgPlay } from '@img/icons/play-circle-instagram.svg';
import { BackgroundValues } from '@stories/Components/Breadcrumb/Breadcrumb';
import CtaLink from '@stories/Components/CtaLink/CtaLink';
import ModalGallery from '@stories/Components/Misc/ModalGallery/ModalGallery';
import ModalGalleryProvider from '@stories/Components/Misc/ModalGallery/ModalGalleryProvider/ModalGalleryProvider';
import * as React from 'react';
import S from './SplitContent.styles';
const SplitContent = ({ anchorId, background, title, image, video, subtitle, content, cta, variant, mediaPosition, }) => {
    useModalGallery({ count: video ? 1 : 0 });
    const [modalOpen, setModalOpen] = React.useState(false);
    const srcs = image
        ? getSrcs(image, 847, 375, 8, 9 / 16)
        : video
            ? video.previewImage
                ? getSrcs(video.previewImage, 847, 375, 8, 9 / 16)
                : [videoUrl(video.videoId, { format: 'jpg' })]
            : [];
    const sizes = `${until(Device.TabletMedium)} 100vw, ${until(Device.ActualDesktop)} 47vw, 793px`;
    return (React.createElement(S.Wrapper, { id: anchorId, layout: "fullWidth", "data-background": background && background !== '' ? background : BackgroundValues.White },
        React.createElement(S.Container, { "data-media-position": mediaPosition ?? 'left', "data-variant": variant ?? 'green' },
            React.createElement(S.Title, null, title),
            React.createElement(S.ImageWrapper, null,
                image && (React.createElement(S.Image, { sizes: sizes, src: srcs[0].split(' ')[0], srcSet: srcs.join(','), alt: image.altText ?? undefined, role: !image.altText ? 'presentation' : undefined, loading: "lazy" })),
                video && (React.createElement(ModalGalleryProvider, { count: 1 },
                    React.createElement(S.VideoButton, { onClick: () => setModalOpen(true), "aria-label": "Open video in modal" },
                        React.createElement(S.Image, { sizes: sizes, src: srcs[0].split(' ')[0], srcSet: srcs.join(','), alt: video.title ?? undefined, role: !video.title ? 'presentation' : undefined, loading: "lazy" }),
                        React.createElement(SvgPlay, null)),
                    React.createElement(ModalGallery, { ariaLabel: video.title ?? 'Video Modal', isOpen: modalOpen, openIndex: 0, media: [video], closeOnBackground: true, showBackground: true, showClose: true, onClose: () => setModalOpen(false) })))),
            React.createElement(S.ContentWrapper, null,
                subtitle && React.createElement(S.SubTitle, null, subtitle),
                React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                cta && (React.createElement(S.LinkWrapper, null,
                    React.createElement(CtaLink, { href: cta.url, target: cta.target, size: "small", variant: !variant || variant === 'green' ? 'white' : 'default' }, cta.text)))))));
};
export default withMotionMax(SplitContent);
